<template>
    <div>
        <header-nav :cur="4" />
        <!-- 搜索 -->
        <div class="nav" v-if="!off">
            <div class="navtab">
                <span class="top">
                    首页&nbsp;>&nbsp;练习&nbsp;>
                    <span class="infor">强化练习</span>
                </span>
            </div>
        </div>
        <!-- 正式考试头部考生信息 -->
        <!-- 练习 -->
        <div class="navtab exercise">
            <div class="box-fixed" v-show="isFixed"></div>
            <div class="leftbox" :class="{ 'is-fixed': isFixed }">
                <!-- exercise为练习,当进入练习界面的时候 -->
                <div class="title" v-if="exercise">道路交通工程</div>
                <div class="write">答题卡</div>
                <ul>
                    <li v-for="(item, index) in indexList" :class="{ activeli: item.check }" :key="index" @click="scrollTo(index)" :name="'position-' + index">
                        {{ item.id }}
                    </li>
                </ul>
            </div>
            <div class="answer">
                <div class="title">
                    选择题
                    <!-- <span>（30分）</span> -->
                </div>
                <div>
                    <div class="timubox" v-for="(item, index) in option" :key="index" :id="'position-' + item.id">
                        <div class="timu">
                            {{ item.title }}
                        </div>
					   <div
					   	class="list"
					   	v-for="(selitem, option_index) in item.selectItem"
					   	:key="selitem.id"
					   	@click="selectAnswer(index,item,selitem,option_index)"
					   	:class="{ listactive: selitem.checkOpt }"
					   >
							     <span :class="{ spanactive: selitem.checkOpt }">{{ selitem.opt }}</span>
							     {{ selitem.cont }}
						</div>
                        <!-- 答案 -->
                        <div class="answer" v-show="show" v-if="!off">
                            <div class="top">正确答案：{{ item.option }}</div>
                            <div class="bottom">
                                <span>答案解析：</span>
                                {{ item.answer }}
                            </div>
                        </div>
                    </div> 
                </div>
                <div class="submit" @click="submit(idItem)">
                    <img src="../../../assets/img/exam/exam.svg" alt="" />
                    我要交卷
                </div>
            </div>
        </div>
        <footer-nav />
    </div>
</template>
<script>
import Vue from 'vue';
import { IndexBar, IndexAnchor, Toast } from 'vant';

Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Toast);
import headerNav from '../../../components/HeaderNav.vue';
import footerNav from '../../../components/FooterBar';
export default {
    components: {
        headerNav,
        footerNav,
    },
    data() {
        return {
            idItem: '',
            off: false,
            // 考试倒计时start
            keepTime: '倒计时开始',
            settime: '',
            flag: false,
            // 考试倒计时end
            // 是否考试题 固定定位
            isFixed: false,
            // 当进入练习页面时
            exercise: false,
            // 当进入模拟考试的时候
            simulation: false,
            show: false,
            indexList: [
                { id: 1,type:'单选题', check: false },
                { id: 2,type:'多选题', check: false },
				{ id: 3,type:'判断题', check: false },
            ],
			limittime:0,
            option: [
                {
                    id: 1,
					type:1,
                    title: '  1.(单选题) 操作系统是计算机的一种系统软件，它有效地管理和控制计算机的（软、硬件资源），合理组织计算机的工作流程，以使整个计算机系统高效地运行操作系统是计算机的一种系统软件，它有效地管理和控制计',
                    selectItem: [
                        { opt: 'A', cont: '并发和（共享）是操作系统的两个基本特征，两者互为依存条件', checkOpt: false },
                        { opt: 'B', cont: '并发和（共享）是操作系统的两个基本特征，两者互为依存条件', checkOpt: false },
                        { opt: 'C', cont: '并发和（共享）是操作系统的两个基本特征，两者互为依存条件', checkOpt: false },
                        { opt: 'D', cont: '并发和（共享）是操作系统的两个基本特征，两者互为依存条件', checkOpt: false },
                    ],

                    option: 'D',
                    answer: '线粒体的分裂都涉及到线粒体的一分为二，因此都依赖于膜的流动性，A项正确；洋葱的分生区细胞不断分裂，比表皮细胞需要能量多，正常线粒体分裂更为活跃，',
                },
            ],
			optuons:[],
			paper:'',
			id:'',
			exam:''
        };
    },
	created() {
		this.id = this.$route.query.wid;
		this.queryExamInfo(this.id);	
	},
    methods: {
		queryExamInfo(id){
		    this.$http.get(this.$api.url +'/uapi/exam/queryExamById',{params:{'wid':id}}).then((response) => {
				console.log(response.data);
				this.paper = response.data.data.paper;
		        this.limittime = this.paper.timeLength;
		        this.optuons = JSON.parse(this.paper.content);
				console.log(this.optuons);
		    }, (response) => {
		        console.log("response"+response.data.rows.length);
		    });
		},
        // 监听滚动条位置
        handleScroll() {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.isFixed = scrollTop > 170 ? true : false;
        },
        // 返回按钮
        back() {
            this.$router.back(-1);
        },
        // 考试倒计时end
        submit(idItem) {
            this.show = true;
        },
        /*
            点击选择单选选项
            @parme curId:当前题的Id
        */
	   selectAnswer(index,item,selitem,option_index){
		   // 判断四个选项有没有为true
		   for (let n = 0; n < this.option[index].selectItem.length; n++) {
			   if(selitem.checkOpt == true){
				   if(item.type != 2){
				   		for (let j = 0; j < this.option[index].selectItem.length; j++) {
							if (n != j) {
								this.option[index].selectItem[n].checkOpt = false;
							}    
				   		}			   
				   }
				   this.option[index].selectItem[option_index].checkOpt = false;
				   
			   }
			   if(selitem.checkOpt == false){
				   if(item.type != 2){
				   		for (let j = 0; j < this.option[index].selectItem.length; j++) {
				   			if (n != j) {
				   				this.option[index].selectItem[n].checkOpt = false;
				   			}    
				   		}				   
				   }
				   this.option[index].selectItem[option_index].checkOpt = true;
			   }
			}   
			
		  var is_sta = false;
		   for (let n = 0; n < this.option[index].selectItem.length; n++) {
			   if (this.option[index].selectItem[n].checkOpt) {
			       is_sta= true;
			   } else {
			       is_sta = false;
			   } 
		   }
		   this.indexList[index].check = is_sta;
		   
	   },
        // 点击左侧跳转到右侧对ele应位置
        scrollTo(index) {
            // document.getElementById('position-' + (index + 1)).scrollTop();
            console.log(document.getElementById('position-' + (index + 1)));
            let ele = document.getElementById('position-' + (index + 1));
            console.log(ele.scrollTop);
            window.scrollTo(0, ele.offsetTop - 80);
        },
    },
};
</script>
<style lang="less" scoped>
    // 公共
    .navtab {
        width: 1280px;
        margin: 0 auto;
    }
    .color {
        color: #2961EF !important;
    }
    .ignore {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }
    // 搜索
    .nav {
        background: #f7f8fa;
        width: 100%;
        // height: 177px;
        .top {
            display: block;
            font-size: 16px;
            color: #777777;
            padding: 19px 0 24px;
            .infor {
                color: #2961EF;
            }
        }
    }
    // 正式考试头部考生信息
    .head {
        width: 100%;
        // height: 219px;
        background: #f7f8fa;
        border-radius: 5px 5px 5px 5px;
        .headbox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 30px 0;
    
            img {
                // flex: 1;
                width: 120px;
                height: 161px;
                margin-right: 19px;
            }
            ul {
                margin-left: -251px;
                // flex: 7;
                display: flex;
                width: 50%;
                flex-wrap: wrap;
                justify-content: space-between;
                li {
                    width: 50%;
                    font-size: 16px;
                    color: #000000;
                    line-height: 40px;
                }
            }
            .time {
                // flex: 1;
                float: right;
                font-size: 22px;
                font-weight: 600;
                color: #333333;
                text-align: center;
                div {
                    width: 234px;
                    height: 59px;
                    line-height: 59px;
                    text-align: center;
                    background: #2961EF;
                    border-radius: 5px 5px 5px 5px;
                    font-size: 36px;
                    font-weight: normal;
                    color: #ffffff;
                    margin-top: 12px;
                }
            }
        }
    }
    // 练习
    .exercise {
        margin-top: 34px;
        // position: fixed;
        // display: flex;
        .leftbox {
            display: inline-block;
            vertical-align: top;
            margin-right: 42px;
            width: 267px;
            background: #f7f8fa;
            // 练习界面样式
            .title {
                font-size: 20px;
                font-weight: 600;
                color: #333333;
                height: 65px;
                padding-left: 14px;
                line-height: 65px;
                border-bottom: 1px dashed #8c97b0;
            }
            // 模拟考试界面样式
            .simulation {
                padding: 11px 16px;
                .count {
                    font-size: 18px;
                    color: #333333;
                    div {
                        height: 59px;
                        line-height: 59px;
                        text-align: center;
                        background: #ebf5ff;
                        border-radius: 5px 5px 5px 5px;
                        opacity: 1;
                        border: 1px solid #c2e0fe;
                        font-size: 36px;
                        color: #2961EF;
                        margin: 13px 0 26px;
                    }
                }
                .our {
                    font-size: 18px;
                    color: #333333;
                    .session {
                        margin-top: 16px;
                        background: #ffffff;
                        padding: 16px 13px;
                        div {
                            font-size: 16px;
                            color: #666666;
                            line-height: 30px;
                        }
                    }
                }
            }
            .write {
                font-size: 18px;
                color: #555555;
                padding-left: 14px;
                margin: 17px 0;
            }
            ul {
                display: flex;
                flex-wrap: wrap;
                padding: 0 16px;
                padding-bottom: 20px;
                li {
                    width: 17%;
                    height: 35px;
                    line-height: 35px;
                    text-align: center;
                    background: #ffffff;
                    border: 1px solid #dddddd;
                    font-size: 16px;
                    color: #999999;
                    margin-right: 2.5%;
                    margin-bottom: 13px;
                    &:nth-child(5n) {
                        margin-right: 0;
                    }
                }
                .activeli {
                    background: #2961EF;
                    color: #ffffff;
                    border: 1px solid #2961EF;
                }
            }
        }
        .is-fixed {
            position: fixed;
            top: 0;
            margin-left: -309px;
        }
        .box-fixed {
            display: inline-block;
            vertical-align: top;
            margin-right: 42px;
            width: 267px;
            background: #f7f8fa;
        }
        .answer {
            display: inline-block;
            width: 75%;
            overflow-y: auto;
            .title {
                font-size: 20px;
                font-weight: 600;
                color: #333333;
                span {
                    color: #2961EF;
                }
            }
            .timubox {
                border-bottom: 7px solid #f7f8fa;
                margin-top: 22px;
                padding-bottom: 40px;
                &:last-child {
                    border-bottom: none;
                }
                .timu {
                    font-size: 18px;
                    color: #333333;
                }
                .list {
                    height: 50px;
                    line-height: 50px;
                    border-radius: 5px 5px 5px 5px;
                    border: 1px solid #e1e1e1;
                    margin-top: 22px;
                    font-size: 16px;
                    color: #888888;
                    span {
                        display: inline-block;
                        width: 59px;
                        height: 50px;
                        line-height: 50px;
                        text-align: center;
                        background: #cdcdcd;
                        border-radius: 5px 5px 5px 5px;
                        border: 1px solid #e1e1e1;
                        font-size: 22px;
                        color: #ffffff;
                        margin-right: 17px;
                    }
                    .spanactive {
                        background: #2961EF;
                    }
                }
                .listactive {
                    border: 1px solid #2961EF;
                    color: #2961EF;
                }
                // 答案
                .answer {
                    background: #fffbf7;
                    border-radius: 5px 5px 5px 5px;
                    border: 1px solid #fde7b5;
                    padding: 15px 11px 37px 26px;
                    margin-top: 23px;
                    width: 95.5%;
                    .top {
                        font-size: 16px;
                        color: #2961EF;
                        margin-bottom: 9px;
                    }
                    .bottom {
                        span {
                            color: #2961EF;
                        }
                        font-size: 16px;
                        line-height: 30px;
                        color: #888888;
                    }
                }
            }
            .quest {
                font-size: 18px;
                color: #333333;
                border-bottom: 7px solid #f7f8fa;
                margin-top: 16px;
                padding-bottom: 30px;
                margin-bottom: 40px;
                textarea {
                    width: 95%;
                    height: 130px;
                    background: #f7f8fa;
                    border-radius: 5px 5px 5px 5px;
                    border: 1px solid #e1e1e1;
                    padding: 11px 19px;
                    margin-top: 19px;
                    &::placeholder {
                        font-size: 16px;
                        color: #999999;
                    }
                }
                // 答案
                .answerlist {
                    background: #fffbf7;
                    border-radius: 5px 5px 5px 5px;
                    border: 1px solid #fde7b5;
                    padding: 15px 11px 37px 26px;
                    margin-top: 23px;
                    width: 95.5%;
                    .bottom {
                        margin-top: 20px;
                        span {
                            color: #2961EF;
                        }
                        font-size: 16px;
                        line-height: 30px;
                        color: #888888;
                    }
                }
            }
    
            .submit {
                display: flex;
                align-items: center;
                margin-bottom: 40px;
                img {
                    width: 22px;
                    height: 26px;
                    margin: 0 14px 0 42px;
                }
                width: 185px;
                height: 51px;
                line-height: 51px;
                background: #2961EF;
                border-radius: 32px 32px 32px 32px;
                font-size: 16px;
                color: #ffffff;
                float: right;
            }
        }
    }
    
</style>